import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { ExportButton } from "@components/Common/Button";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function Act({ developerId, header }) {
    const { t } = useTranslation();
    const params = useParams();
    const { apiData } = useAppApi(
        url_reverse("api:developer:statistics:act", { developer_id: developerId, kind: params.kind })
    );
    const { ext_api_get } = useRequest();

    if (!apiData) return;

    const moment = require("moment");
    const chosenDate = apiData.forms_data
        ? moment(new Date(apiData.forms_data.main.data.year, apiData.forms_data.main.data.month, 0))
        : null;
    const goodDate = chosenDate && moment().startOf("month") >= chosenDate;

    const headerTools = ["nivel_act"].includes(params.kind) && (
        <DevForm.Button
            variant="secondary"
            size="sm"
            disabled={!goodDate}
            name="currate"
            onClick={(ev) => {
                const dt = chosenDate.format("YYYY-MM-DD");
                ext_api_get(ev, `/play/currency_rate/?date=${dt}`, {
                    then: (resp) => {
                        alert(`${dt}\n1 EUR = ${resp.eur_rub} RUB\n1 EUR = ${resp.eur_usd} USD`);
                    },
                });
            }}
        >
            {t("Валютный курс")}
        </DevForm.Button>
    );

    const buttons = (
        <ExportButton
            disabled={!goodDate}
            buildReport={params.kind}
            prms={{
                "main-month": apiData.forms_data.main.data.month,
                "main-year": apiData.forms_data.main.data.year,
                "main-order_type": apiData.forms_data.main.data.order_type,
            }}
        />
    );

    return (
        <CommonCard header={header} headerTools={headerTools}>
            {!goodDate && (
                <Alert variant="warning">
                    {t("Обратите внимание! Построить можно отчёт за любой прошедший месяц.")}
                </Alert>
            )}
            <RenderForm buttons={buttons} />
        </CommonCard>
    );
}
